var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_banner_data
    ? _c("div", {
        staticClass: "google_ad_banner_wrapper",
        staticStyle: { width: "100%" },
        domProps: { innerHTML: _vm._s(_vm.bannerMkp) },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }